
import { AnimatePresence, motion } from "framer-motion";

function LeftBarAnimation({ children, showDiv, variants, overlayDirection }) {
  return (<AnimatePresence
    initial={false}
    mode="wait"
    onExitComplete={() => null}
  >
    {showDiv &&
      <motion.div
        className={`${window.innerWidth < 750 ? (overlayDirection === "left" ? "absolute left-0 top-0 bottom-0" : "absolute right-0 top-0 bottom-0") : ""} max-w-[190px] z-30 flex h-full flex-col bg-white dark:!bg-navy-800 dark:text-white`}
        initial={{ width: "0px", minWidth: "0px" }}
        animate={{ width: "190px", minWidth: "190px" }}
        exit={{ width: "0px", minWidth: "0px" }}
      >
        <motion.div
          className={`overflow-x-auto overflow-y-auto h-full ${overlayDirection === "left" ? "border-r border-gray-300" : "border-l border-gray-300"}`}
          variants={variants}
          initial="hidden"
          animate="visible"
          exit="exit"
        >
          {children}
        </motion.div>
      </motion.div>
    }
  </AnimatePresence>
  )
}

export default LeftBarAnimation